import {
  APP_LOGIN,
  APP_LOGIN_SUCCESS,
  APP_LOGIN_FAILURE
} from "../../store/constants/general";
import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../store/constants/general";
import { put, takeLatest } from "redux-saga/effects";

const WIRED_TOKEN = "871216";

function* checkAuth(action) {
  if (action.pinNumber === WIRED_TOKEN) {
    yield put({
      type: SUCCESS_MESSAGE,
      message: "Successfully logged in"
    });
    yield put({ type: APP_LOGIN_SUCCESS });
  } else {
    yield put({ type: ERROR_MESSAGE, message: "Invalid PIN Number" });
    yield put({ type: APP_LOGIN_FAILURE });
  }
}

export default function* rootSaga() {
  yield takeLatest(APP_LOGIN, checkAuth);
}
